module.exports = __webpack_public_path__ + "img/icon-arrow-secondary__up.0e48c203.svg";